<ng-container *ngIf='indirizzo; else waiting'>
    <div class="actionBar" style="margin-top:20px">
        <ng-container *ngIf='indirizzo!.denominazione; else _new'>
            <h5  class="roboSubTitle col">{{indirizzo!.denominazione}}<br *ngIf="innerWidth! <= 767"></h5>
            <button  type="submit" class="btn btn-light" style="margin-left: 10px;" (click)='refresh()'>{{ 'general.undo' | translate }}</button>
            <button  type="submit" class="btn btn-success btnAr4m" style="margin-left: 10px;" (click)='save()'>{{ 'general.save' | translate }}</button>
            <button  type="submit" class="btn btn-light" style="margin-left: 10px;" (click)='delete()'>{{ 'general.delete' | translate }}</button>
        </ng-container>
        <ng-template #_new >
            <h5  class="roboSubTitle col">{{ 'general.newAddress' | translate }}<br *ngIf="innerWidth! <= 767"></h5>
            <button  type="submit" class="btn btn-light" style="margin-left: 10px;" (click)='refresh()'>{{ 'general.undo' | translate }}</button>
            <button  type="submit" class="btn btn-success btnAr4m" style="margin-left: 10px;" (click)='save()'>{{ 'general.save' | translate }}</button>
        </ng-template>
    </div>
    <hr>

    <ng-template>
        <!-- ENTE -->
        <div class="row" style="margin-top:20px">
            <div  [ngClass]="{'col-6' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
                <!-- DENOMINAZIONE  -->
                <label  class="roboSubTitle" [ngClass]="(indirizzo.denominazione.length == 0)?'colorRed':''">{{ 'users.personal.denominazione' | translate }}</label>
                <input class="form-control" type="text" (keyup)="indirizzo.denominazione = sostituiscicarattere(indirizzo.denominazione)"
                    [ngClass]="(indirizzo.denominazione.length==0)?'borderRed':''" [(ngModel)]="indirizzo.denominazione" >
            </div>
        </div>
    </ng-template>
    
    <div class="row"> 
        <div class="col-4">
            <label  class="roboSubTitle">Denominazione / Ragione sociale</label>
            <div class="input-group mb-4">
                <input *ngIf="indirizzo.persona_fisica == 'f'" class="form-control" type="text" placeholder="Denominazione" [(ngModel)]="indirizzo.denominazione">
                <div *ngIf="indirizzo.persona_fisica == 't'" class="input-group">
                    <input type="text" placeholder="Nome" class="form-control" [(ngModel)]="indirizzo.nome">
                    <input type="text" placeholder="Cognome" class="form-control" [(ngModel)]="indirizzo.cognome">
                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" (click)="setPersonaFisica()">Persona giuridica</button>
                </div>
                <div class="btn-group" role="group">
                    <button *ngIf="indirizzo.persona_fisica == 'f'" class="btn btn-outline-secondary" type="button" id="button-addon2" (click)="cercaPA()">PA</button>
                    <button *ngIf="indirizzo.persona_fisica == 'f'" class="btn btn-outline-secondary" type="button" id="button-addon2" (click)="setPersonaFisica()">Persona fisica</button>
                </div>
                
            </div>

            <div class="dropdown-menu" [ngClass]="{'show': elencoPA && elencoPA.length > 0}">
                <ul class="list-unstyled mb-0">
                <li *ngFor="let risultato of elencoPA" 
                    class="dropdown-item" 
                    (click)="selezionaRisultato(risultato)">
                    {{ risultato.des_amm }}
                </li>
                </ul>
            </div>
        </div>
        
        <!--<div class="col-4">
             EMAIL  
            <label  class="roboSubTitle">Denominazione / Ragione sociale</label>
            <input class="form-control" type="text"  [(ngModel)]="indirizzo.denominazione">
        </div>-->
        <div class="col-3">
            <!-- EMAIL  -->
            <label  class="roboSubTitle">Email</label>
            <input class="form-control" type="text"  [(ngModel)]="indirizzo.email">
        </div>
        <div class="col-3">
            <!-- PEC  -->
            <label  class="roboSubTitle">PEC</label>
            <input class="form-control" type="text"  [(ngModel)]="indirizzo.pec">
        </div>
    </div>
   
    <div class="row" style="margin-top: 10px;">
        <div class="col-3">
        <!-- CODICE FISCALE  -->
        <label  class="roboSubTitle" [ngClass]="(indirizzo.codice_fiscale)?'colorRed':''">{{'configuration.rubrica.cf' | translate}}</label>
        <input class="form-control" type="text"  [(ngModel)]="indirizzo.codice_fiscale" [ngClass]="(indirizzo.codice_fiscale.length == 0)?'borderRed':''">
        </div>

        <div class="col-2">
            <!-- PAESE  -->
            <label class="roboSubTitle" [ngClass]="(indirizzo.id_paese.length != 2)?'colorRed':''">{{'configuration.rubrica.paese' | translate}}</label>
            <input class="form-control" type="text" [(ngModel)]="indirizzo.id_paese" [ngClass]="(indirizzo.id_paese.length != 2)?'borderRed':''"
            maxlength="2" oninput="javascript: this.value= this.value.toLocaleUpperCase(); if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" list="countries">
        </div>
        <div class="col-3">
            <!-- PARTITA IVA  -->
            <label  class="roboSubTitle" [ngClass]="(indirizzo.partita_iva.length == 0)?'colorRed':''">{{'configuration.rubrica.table.piva' | translate}}</label>
            <input class="form-control" type="text"  [(ngModel)]="indirizzo.partita_iva" [ngClass]="(indirizzo.partita_iva.length == 0)?'borderRed':''"
            maxlength="11" oninput="javascript: this.value= this.value.toLocaleUpperCase(); if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
        </div>
        <!-- CODICE UNIVOCO -->
        <div class="col-2 form-group form-check" style="margin-bottom: 5px;">
            <div class="userCheckBox" >
                <label  class="roboSubTitle">Codice destinatario</label>
                <input maxlength="7" class="form-control" type="text"  [(ngModel)]="indirizzo.codice_destinatario" [ngClass]="((!indirizzo.codice_destinatario || indirizzo.codice_destinatario))?'borderRed':''">
            </div>
            <div class="dropdown-menu" [ngClass]="{'show': elencoSfe && elencoSfe.length > 0}">
                <ul class="list-unstyled mb-0">
                <li *ngFor="let risultato of elencoSfe" 
                    class="dropdown-item" 
                    (click)="selezionaRisultatoSfe(risultato)">
                    {{ risultato.des_ou }} - {{ risultato.cod_uni_ou }}
                </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row" style="margin-top: 10px;">
        <div class="col-8">
            <!-- INDIRIZZO  -->
            <label  class="roboSubTitle">{{ 'users.personal.tabs.sede.indirizzo' | translate }}</label>
            <input class="form-control" type="text" (keyup)="indirizzo.indirizzo = sostituiscicarattere(indirizzo.indirizzo)"  [(ngModel)]="indirizzo.indirizzo" >
        </div>
        <div class="col-2">
            <!-- NUMERO CIVICO  -->
            <label  class="roboSubTitle">{{ 'users.personal.tabs.sede.civico' | translate }}</label>
            <input class="form-control" type="text"  [(ngModel)]="indirizzo.civico" >
        </div>
    </div>
    <div class="row" style='margin-top: 20px;'>
        <div class="col-2">
            <!-- NAZIONE  -->
            <label  class="roboSubTitle">{{ 'users.personal.tabs.sede.nazione' | translate }}</label>
            <input class="form-control" type="text"  [(ngModel)]="indirizzo.nazione" 
            maxlength="2" oninput="javascript: this.value= this.value.toLocaleUpperCase(); if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" 
            data-address="sede" (focusout)="addressHelper.setGroup($event)" list="countries">
        </div>
        <div class="col-2">
            <!-- PROVINCIA  -->
            <label  class="roboSubTitle">{{ 'users.personal.tabs.sede.prov' | translate }}</label>
            <input class="form-control" type="text"  [(ngModel)]="indirizzo.provincia" 
            maxlength="2" oninput="javascript: this.value= this.value.toLocaleUpperCase(); if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" 
            data-address="sede" data-addpart="province" [attr.list]="addressHelper.isActiveGroup('sede') ?'provinces':null" (focusout)="addressHelper.setCities($event)" (focus)="addressHelper.setCities($event)">
        </div>
        <div class="col-4">
            <!-- CITTÀ-->
            <label  class="roboSubTitle">{{ 'users.personal.tabs.sede.citta' | translate }}</label>
            <input class="form-control" type="text"  [(ngModel)]="indirizzo.comune"  (keyup)="indirizzo.comune = indirizzo.comune.toLocaleUpperCase()" 
            data-address="sede" data-addpart="city" [attr.list]="addressHelper.isActiveGroup('sede')?'cities' : null " 
                    (focusout)="addressHelper.setPotsalCodes($event)" (focus)="addressHelper.setPotsalCodes($event)" (keydown)="addressHelper.testCities($event)" >
        </div>
        <div class="col-2">
            <!-- CAP  -->
            <label  class="roboSubTitle">{{ 'users.personal.tabs.sede.cap' | translate }}</label>
            <input class="form-control" type="text"  [(ngModel)]="indirizzo.cap"
            maxlength="5" oninput="javascript: this.value = this.value.replace(/[^\d]*/g, '');if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            data-address="sede" data-addpart="cap" [attr.list]="addressHelper.isActiveGroup('sede') ?'postcodes' : null " (focus)="addressHelper.getPostalCode($event)">
        </div>
    </div>


<datalist id="countries" style="height:5.1em;overflow:hidden">
    <option *ngFor="let country of addressHelper.getCountries()" value="{{country}}">
</datalist>
<datalist id="provinces" style="height:5.1em;overflow:hidden">
    <option *ngFor="let province of addressHelper.getProvinces()" value="{{province}}">
</datalist>
<datalist id="cities">
    <option *ngFor="let city of addressHelper.getCities()" value="{{city}}">
</datalist>
<datalist id="postcodes">
    <option *ngFor="let pcode of addressHelper.getPostalCodes()" value="{{pcode}}">
</datalist>    



</ng-container>
<ng-template #waiting>
    <app-loading></app-loading>
</ng-template>
